import React, { Component } from "react";
import Loader from "react-loader-spinner";
import moment from 'moment';
import DatePicker from "react-datepicker";
import $ from 'jquery';
class ResourceLeaderBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "dev",
      fromDate: '',
      toDate: '',
      dateFilterShow: false,
      isLoading: false,
      period: '',
      resourceLeaderBoardList: [],
      projectDrops: [],
      popupVisible: null,
      users: [
        { rank: "🥇", name: "John Doe", role: "Manager", points: 1200, img: "https://i.pravatar.cc/40" },
        { rank: "🥈", name: "Jane Smith", role: "Developer", points: 1100, img: "https://i.pravatar.cc/41" },
        { rank: "🥉", name: "Emily Davis", role: "Designer", points: 1000, img: "https://i.pravatar.cc/42" }
      ]
    };

  }

  componentDidMount = async () => {
    this.setState({ isLoading: true });
    this.getResourceLeaderBoard().then(data => {
      console.log("projects", data)
      this.setState({ resourceLeaderBoardList: data.data });

    });

  }
  getResourceLeaderBoard = (searchData) => {
    return new Promise((resolve, reject) => {
      fetch(global.config.api.remotePath + 'user/get-resource-leaderboard-data', {
        method: 'post',
        body: JSON.stringify(searchData),
        headers: {
          'content-type': 'application/json'
        }
      }).then((res) => res.json())
        .then(data => {
          console.log(data.data, "getLeaders");
          if (data) {
            this.setState({ isLoading: false });
            resolve({ success: true, data: data.data })
          }
          else {
            resolve({ success: false, data: [] })
          }
        })
        .catch(err => {
          resolve({ success: false, err: err })
        })
    })
  }
  periodDropChange = async (event) => {
    console.log(event.target.value, 8989800)
    if (event.target.value == 7) {
      await this.setState({ dateFilterShow: true, period: event.target.value });
      $('.show_date_filter').show();
    }
    else {
      await this.setState({ dateFilterShow: false, period: event.target.value });
      $('.show_date_filter').hide();
    }
    if (event.target.value == 0) {
      await this.setState({ fromDate: new Date('2016-08-03'), toDate: new Date(moment().format('YYYY-MM-DD')) });
    } else {
      if (event.target.value == 1) {
        var startDateOfTheYear = new Date(moment().startOf('month').format('YYYY-MM-DD'));
        var endDateOfTheYear = new Date(moment().endOf('month').format('YYYY-MM-DD'));
      } else if (event.target.value == 2) {
        var startDateOfTheYear = new Date(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
        var endDateOfTheYear = new Date(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        //console.log('form date', startDateOfTheYear);

      } else if (event.target.value == 3) {

        var startDateOfTheYear = new Date(moment().quarter(moment().quarter()).startOf('quarter').format('YYYY-MM-DD'));
        var endDateOfTheYear = new Date(moment().quarter(moment().quarter()).endOf('quarter').format('YYYY-MM-DD'));
        //console.log('form date', startDateOfTheYear);

      } else if (event.target.value == 4) {

        var startDateOfTheYear = new Date(moment().quarter(moment().quarter()).subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
        var endDateOfTheYear = new Date(moment().quarter(moment().quarter()).subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD'));

      } else if (event.target.value == 5) {
        // var startDateOfTheYear = new Date(moment().month('April').startOf('month').format('YYYY-MM-DD'))


        if (moment().month() >= 3) { // April (3-based index)
          var startDateOfTheYear = new Date(moment().month(3).startOf("month").format("YYYY-MM-DD")); // April 1st of the current year
          // endDate = moment().add(1, "year").month(2).endOf("month").format("YYYY-MM-DD"); // March 31st of next year
        } else {
          var startDateOfTheYear = new Date(moment().subtract(1, "year").month(3).startOf("month").format("YYYY-MM-DD")); // April 1st of last year
          // endDate = moment().month(2).endOf("month").format("YYYY-MM-DD"); // March 31st of the current year
        }

        var endDateOfTheYear = new Date(moment().add(1, 'year').month('March').endOf('month').format('YYYY-MM-DD'))

      } else if (event.target.value == 6) {

        if (moment().quarter() === 2) {
          var thisFiscalStart = moment().month('April').startOf('month').format('YYYY-MM-DD')
          var thisFiscalEnd = moment().add(1, 'year').month('March').endOf('month').format('YYYY-MM-DD')
        } else {
          var thisFiscalStart = moment().subtract(1, 'year').month('April').startOf('month').format('YYYY-MM-DD')
          var thisFiscalEnd = moment().month('March').endOf('month').format('YYYY-MM-DD')
        }

        var startDateOfTheYear = new Date(moment(thisFiscalStart).subtract(1, 'year').format('YYYY-MM-DD'))
        var endDateOfTheYear = new Date(moment(thisFiscalEnd).subtract(1, 'year').format('YYYY-MM-DD'))
      }
      var currentDate = new Date(moment().format('YYYY-MM-DD'));
      if (endDateOfTheYear > currentDate) {
        endDateOfTheYear = currentDate;
      }
      console.log(startDateOfTheYear, endDateOfTheYear, 89898);

      await this.setState({ fromDate: startDateOfTheYear, toDate: endDateOfTheYear });
    }

    $('.budget_hide').find('#period').val(event.target.value);
  }

  detailFilterSubmit = () => {
    var searchData = [];
    this.setState({ isLoading: true });
    searchData.push({ 'fromDate': moment(this.state.fromDate).format('YYYY-MM-DD'), 'toDate': moment(this.state.toDate).format('YYYY-MM-DD') });
    this.getResourceLeaderBoard(searchData).then(data => {
      console.log("projects", data)
      this.setState({ resourceLeaderBoardList: data.data });
    });
  }

  togglePopup = (index) => {
    this.setState({ popupVisible: this.state.popupVisible === index ? null : index });
  };
  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };


  render = () => {
    console.log(this.state.resourceLeaderBoardList, 55);
    return (
      <div className="leaderboard-container">
        <div className="leaderboard">
          <div className="row">
            <div className="col-md-2 width-auto">
              <div className="form-group">
                <label>Period </label>
                <select className="form-control form-control-sm" name="period" id="period" onChange={this.periodDropChange} defaultValue={5}>
                  <option>Select</option>
                  <option value="0">All</option>
                  <option value="1">Current Month</option>
                  <option value="2">Previous Month</option>
                  <option value="3">Current Qtr</option>
                  <option value="4">Previous Qtr</option>
                  <option value="5">Current FY</option>
                  <option value="6">Previous FY</option>
                  <option value="7">Custom</option>
                </select>
              </div>
            </div>

            <div className="show_date_filter" style={{ display: 'none' }}>
              <div className='col-md-3'>
                <div className="form-group">
                  <label>From Date</label>
                  <DatePicker selected={this.state.fromDate} onChange={date => this.setState({ fromDate: date })} dateFormat="yyyy-MM-dd" className="form-control form-control-sm form_date" />
                </div>
              </div>
              <div className='col-md-3'>
                <div className="form-group">
                  <label>To Date</label>
                  <DatePicker selected={this.state.toDate} onChange={date => this.setState({ toDate: date })} dateFormat="yyyy-MM-dd" className="form-control form-control-sm to_date" />
                </div>
              </div>
            </div>
            <div className='col-md-3' style={{ 'margin-top': '25px' }}>
              <div className="form-group" >
                <button onClick={() => this.detailFilterSubmit()} className="btn btn-info btn-sm filter-btn">Filter</button>
                <a href="/resource-ledearboard" className="btn btn-sm btn-warning">Clear</a>
              </div>
            </div>

          </div>
          <h2 className="leaderboard-title">Resource Leaderboard</h2>
          <div className="tabs">
            <button className={this.state.activeTab === "dev" ? "active" : ""} onClick={() => this.setActiveTab("dev")}>DEV</button>
            <button className={this.state.activeTab === "pl" ? "active" : ""} onClick={() => this.setActiveTab("pl")}>PL</button>
          </div>


          {this.state.activeTab === "dev" ? <table className="leaderboard-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>User</th>
                {/* <th>Role</th> */}
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.resourceLeaderBoardList?.dev_result?.length > 0 && this.state.resourceLeaderBoardList.dev_result.map((user, index) => {
                  let rankLabel = '';
                  switch (index + 1) {
                    case 1:
                      rankLabel = "🥇";
                      break;
                    case 2:
                      rankLabel = "🥈";
                      break;
                    case 3:
                      rankLabel = "🥉";
                      break;
                    default:
                      rankLabel = index + 1;
                  }

                  return (
                    <>
                      <tr key={index} className={'rank' + (index + 1)}>
                        <td>{rankLabel}</td>

                        <td className="user-cell" colSpan='2'>
                          <img
                            className="user-img"
                            src="https://i.pravatar.cc/40"
                            alt={user.first_name}
                          />
                          <span>{user.first_name + ' ' + user.last_name}</span>
                        </td>

                        <td className="points" colspan="2" onClick={() => this.togglePopup(index)}>
                          {user.total_score}
                          <span className="dropdown-arrow">
                            {this.state.popupVisible === index ? '▲' : '▼'}
                          </span>
                        </td>
                      </tr>

                      {this.state.popupVisible === index && (
                        <>
                          <tr className="breakdown-row">
                            <td>Type</td>
                            <td>Percentage</td>
                            <td>Slab</td>
                            <td>Points</td>


                          </tr>
                          <tr className="breakdown-row">
                            <td>Man Day Deviation</td>
                            <td>{user.man_day_deviation_percent}</td>
                            <td>{user.man_day_deviation_slab}</td>
                            <td> {user.man_day_points}</td>

                          </tr>
                          <tr className="breakdown-row">
                            <td>Calendar Day Deviation</td>
                            <td>{user.calendar_day_deviation_percent}</td>
                            <td>{user.calendar_day_deviation_slab}</td>
                            <td> {user.calendar_day_points}</td>
                          </tr>
                          <tr className="breakdown-row">
                            <td>Ticket Closure Deviation</td>
                            <td>{user.ticket_closure_percentage_score}</td>
                            <td>{user.ticket_closure_deviation_slab}</td>
                            <td> {user.ticket_closure_points}</td>
                          </tr>
                          <tr className="breakdown-row">
                            <td>Ticket Logged Deviation</td>
                            <td>{user.ticket_logged_percentage_score}</td>
                            <td>{user.ticket_logging_deviation_slab}</td>
                            <td> {user.ticket_logging_points}</td>

                          </tr>
                        </>
                      )}
                    </>

                    // <tr key={index} className={'rank' + (index + 1)}>
                    //   <td>{rankLabel}</td>
                    //   <td className="user-cell">
                    //     <img
                    //       className="user-img"
                    //       src="https://i.pravatar.cc/40"
                    //       alt={user.first_name}
                    //     />
                    //     <span>{user.first_name + ' ' + user.last_name}</span>
                    //   </td>
                    //   <td className="points" onClick={() => this.togglePopup(index)}>
                    //     {user.total_score}
                    //     {this.state.popupVisible === index && (
                    //       <div className="points-popup">
                    //         <p><strong>Breakdown:</strong></p>

                    //         <p>Man Day Deviation: {user.man_day_points}</p>
                    //         <p>Calendar Day Deviation: {user.calendar_day_points}</p>
                    //       </div>
                    //     )}
                    //   </td>
                    //   {/* <td className="rank-label">{rankLabel}</td>  */}
                    // </tr>

                  );
                })
              }
            </tbody>
          </table> : ''}

          {this.state.activeTab === "pl" ? <table className="leaderboard-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>User</th>
                {/* <th>Role</th> */}
                <th>Points</th>
              </tr>
            </thead>
            <tbody>
              {this.state.resourceLeaderBoardList?.pl_result?.length > 0 && this.state.resourceLeaderBoardList.pl_result.map((user, index) => {
                let rankLabel = '';
                switch (index + 1) {
                  case 1:
                    rankLabel = "🥇";
                    break;
                  case 2:
                    rankLabel = "🥈";
                    break;
                  case 3:
                    rankLabel = "🥉";
                    break;
                  default:
                    rankLabel = index + 1;
                }

                return (
                  <tr key={index} className={'rank' + (index + 1)}>
                    <td>{rankLabel}</td>
                    <td className="user-cell">
                      <img
                        className="user-img"
                        src="https://i.pravatar.cc/40"
                        alt={user.first_name}
                      />
                      <span>{user.first_name + ' ' + user.last_name}</span>
                    </td>
                    <td className="points" onClick={() => this.togglePopup(index)}>
                      {user.weighted_score}
                      {this.state.popupVisible === index && (
                        <div className="points-popup">
                          <p><strong>Breakdown:</strong></p>
                          <p>Man Day Deviation: {user.deviation_percentage_value}</p>
                          <p>Calendar Day Deviation: {user.calendar_day_deviation_value}</p>
                          <p>So Aging Deviation: {user.so_aging}</p>
                        </div>
                      )}
                    </td>
                    {/* <td className="rank-label">{rankLabel}</td>  */}
                  </tr>
                );
              })}
            </tbody>
          </table> : ''}
        </div>
      </div>
    )
  }
}

export default ResourceLeaderBoard;